﻿import { Component, Attribute, Input, Output } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";

@Component({
    module: FIQAssist,
    selector: 'prioritybar',
    template: `<radiobar read-only="$ctrl.readOnly" group="priority" tooltip-class="customTooltipTB" tooltip-placement="bottom" uib-tooltip="{{'PRIORITY_TOOLTIP' | translate}}: {{$ctrl.priority.toUpperCase() | translate}}" value="$ctrl.priority" onoptionchanged="$ctrl.onoptionchanged(value,text)">
                                    <radiobaroption value="'low'" text="('LOW' | translate)" notallowed="false" activecolor="'blue'"></radiobaroption>
                                    <radiobaroption value="'medium'" text="('MEDIUM' | translate)" notallowed="false" activecolor="'blue'"></radiobaroption>
                                    <radiobaroption value="'high'" text="('HIGH' | translate)" notallowed="false" activecolor="'red'"></radiobaroption>
                                </radiobar>`
})
export class PriorityBar {
    @Input() public readOnly: boolean;

    private _priority: any;
    @Input()
    public get priority(): any {
        return this._priority;
    }
    public set priority(priority: any) {
        let p = this._priority;
        this._priority = priority;
        if (p !== priority && p != undefined)
            this.onprioritychanged({ priority: priority });
    }

    public onoptionchanged(value: any, text: string) {
        this.priority = value;
    }

    @Output() public onprioritychanged: (args: { priority: any }) => void;

}

